
import { Route } from '@/app/router'

const QualityTypes = () => import('./index.vue')

const QualityTypesProps = ['page', 'perPage']

export default [
	new Route('/quality-types/:conditionTypeId?', QualityTypes)
		.as('Dashboard:QualityTypes')
		.permissions(['VIEW_VEHICLES'])
		.props(QualityTypesProps)
]
